import React from 'react';
import EmptyMessage from '../components/EmptyMessage';

const RestrictedView = () => (
  <EmptyMessage section="Restricted" />
);

export default RestrictedView;
